import { createSlice } from "@reduxjs/toolkit";

export interface MyProfileUIState {
  aboutPermissionsDialogOpen: boolean;
}

const initialState: MyProfileUIState = {
  aboutPermissionsDialogOpen: false,
};

const myProfileUISlice = createSlice({
  name: "myProfileUI",
  initialState,
  reducers: {
    openAboutPermissionsDialog: (state) => {
      state.aboutPermissionsDialogOpen = true;
    },
    closeAboutPermissionsDialog: (state) => {
      state.aboutPermissionsDialogOpen = false;
    },
    resetMyProfileUIState: () => initialState,
  },
});

export const { openAboutPermissionsDialog, closeAboutPermissionsDialog, resetMyProfileUIState } =
  myProfileUISlice.actions;
export default myProfileUISlice.reducer;
